<template>
    <div class="manager-list">
        <h3 class="page-title">管理员列表</h3>
        <!-- <el-button type="primary" class="add-btn" @click="onAddManager">创建管理员</el-button> -->
        <el-table
            v-loading="loading.userList"
            :data="userList"
            style="width: 100%">
            <el-table-column
                prop="username"
                label="用户名"
                width="180">
            </el-table-column>
            <el-table-column
                prop="account"
                label="账号"
                width="180">
            </el-table-column>
            <el-table-column
                prop="phone"
                label="手机号"
                width="180">
            </el-table-column>
            <el-table-column
                prop="password"
                label="密码">
            </el-table-column>
            <el-table-column
                prop="folderNames"
                label="关联文件夹">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button
                        size="mini"
                        @click="handleCopy(scope.row)">复制</el-button>
                    <!-- <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <add-manager
            :edit-user-info="editUserInfo"
            :is-show-dialog="isShowDialog"
            @hide="hideAddMangerDilog" />
    </div>
</template>

<script>
import api from '@/api/index.js'
import AddManager from './AddManager'

export default {
    name: 'ManagerList',
    components: {
        AddManager
    },
    data () {
        return {
            isShowDialog: false,
            loading: {
                userList: false
            },
            editUserInfo: {},
            userList: []
        }
    },
    created () {
        this.getUserList()
    },
    methods: {
        async getUserList () {
            try {
                this.loading.userList = true
                const res = await api.loadUserList({})
                this.userList = res.data.list || []
            } catch (error) {
                console.error(error)
            } finally {
                this.loading.userList = false
            }
        },
        onAddManager () {
            this.editUserInfo = null
            this.isShowDialog = true
        },
        hideAddMangerDilog (reload) {
            this.isShowDialog = false
            if (reload) {
                this.getUserList()
            }
        },
        handleCopy (user) {
            console.log(user, 'ssss')
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', `账号：${user.phone}，密码：${user.password}`);
            input.select();
            if (document.execCommand('copy')) {
                document.execCommand('copy');
                this.$message.success('复制成功');
            }
            document.body.removeChild(input);
        },
        handleEdit (info) {
            this.isShowDialog = true
            this.editUserInfo = info
        },
        handleDelete () {

        }
    }
}
</script>

<style lang="scss" scoped>
.page-title {
    margin-bottom: 20px;
    color: #606266;
}
.manager-list {
    padding: 20px;
    .add-btn {
        margin: 20px 0;
    }
}
</style>